module.exports = __webpack_public_path__ + "img/title@2x.bdb61314.png";